import { render, staticRenderFns } from "./LugarSolicitudMaterial.vue?vue&type=template&id=68b95bc8&scoped=true"
import script from "./LugarSolicitudMaterial.vue?vue&type=script&lang=js"
export * from "./LugarSolicitudMaterial.vue?vue&type=script&lang=js"
import style0 from "./LugarSolicitudMaterial.vue?vue&type=style&index=0&id=68b95bc8&prod&lang=css"
import style1 from "./LugarSolicitudMaterial.vue?vue&type=style&index=1&id=68b95bc8&prod&scoped=true&lang=css"
import style2 from "./LugarSolicitudMaterial.vue?vue&type=style&index=2&id=68b95bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b95bc8",
  null
  
)

export default component.exports